import AuthInput from "../AuthInput";

const EmailStep = ({
  step,
  email,
  setEmail,
  onVerify,
  setError,
  loading,
  error,
  infoText,
}) => {
  return (
    <div>
      <AuthInput
        name="email"
        type="email"
        setError={setError}
        value={email}
        step={step}
        setValue={setEmail}
        onChange={(e) => setEmail(e.target.value.replace(/\s/g, ""))}
        placeholder="Enter your email"
        buttonText="Continue"
        onButtonClick={onVerify}
        loading={loading}
        error={error}
      />
      <p className="text-base text-primary p-3 w-full sm:w-[70%] mx-auto">
        {infoText}
      </p>
    </div>
  );
};

export default EmailStep;
